export { default } from './Product'
